import type { GuestListId } from '@/lib/bff/guests'
import { isGuestListId } from '@/lib/guests/guest-lists'

const STORAGE_KEY = 'visitone.guestsLastList'

type Stored = Record<string, GuestListId>

function read(): Stored {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as Record<string, unknown>
    const next: Stored = {}
    for (const [tenantId, value] of Object.entries(parsed)) {
      if (typeof value === 'string' && isGuestListId(value)) next[tenantId] = value
    }
    return next
  } catch {
    return {}
  }
}

export function getLastUsedGuestList(tenantId: string): GuestListId | null {
  if (!tenantId) return null
  return read()[tenantId] ?? null
}

export function setLastUsedGuestList(tenantId: string, list: GuestListId): void {
  if (!tenantId) return
  try {
    const next = { ...read(), [tenantId]: list }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    // Non-fatal: the list still opens for this session.
  }
}
